import styled from "styled-components";

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  background-color: white;
`;

export const Header = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 1px solid #e0e0e0;
`;

export const TabContainer = styled.div`
  display: flex;
  border-bottom: 2px solid #e0e0e0;
`;

export const Tab = styled.div<{ active: boolean }>`
  flex: 1;
  padding: 16px;
  text-align: center;
  font-size: 16px;
  font-weight: ${props => props.active ? '600' : '400'};
  color: ${props => props.active ? '#000' : '#999'};
  border-bottom: ${props => props.active ? '3px solid #1FBC70' : 'none'};
  margin-bottom: -2px;
  cursor: default;
  transition: all 0.3s ease;
`;

export const ContentWrap = styled.div`
  padding: 24px 7%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Message = styled.div`
  font-size: 15px;
  color: #000;
  text-align: center;
  margin-bottom: 8px;
`;

export const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  text-align: left;
`;

export const InputWrap = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  background-color: #F5F5F5;
  padding: 0 16px;
  margin-bottom: 12px;

  input {
    flex: 1;
    font-size: 15px;
    border: none;
    outline: none;
    background-color: transparent;
    color: #000;

    &::placeholder {
      color: #999;
    }
  }
`;

export const HelperText = styled.div`
  font-size: 13px;
  color: #666;
  margin-top: -8px;
  margin-bottom: 12px;
  text-align: left;
  line-height: 1.5;
`;

export const ErrorMessage = styled.div`
  margin-top: -8px;
  margin-bottom: 12px;
  color: #FC324A;
  font-size: 13px;
  text-align: left;
`;

export const BottomButton = styled.button`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 48px);
  max-width: calc(480px - 48px);
  height: 52px;
  border: none;
  font-weight: 600;
  font-size: 16px;
  background-color: #CCCCCC;
  border-radius: 12px;
  color: white;
  cursor: pointer;

  &.active {
    background-color: #1FBC70;

    &:hover {
      background-color: #18a860;
    }

    &:active {
      background-color: #159150;
    }
  }

  &:disabled {
    background-color: #CCCCCC;
    cursor: not-allowed;
  }
`;
